import { z } from '@harvestiq/zod';
import { dbSigningAgentSchema } from '../agents/db-signing-agent';
import { dbEntityOwnerSchema } from '../entity-owners/db-entity-owner';
import { dbMediaSchema } from '../media/db-media';
import { dbRecordMediaSchema } from '../media/db-record-media';

// @todo double-check why it is undefined/null for some props: capabilities, createdAt, updatedAt, deletedAt and User_Role
const roleSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  capabilities: z.array(z.string()).optional().nullable(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  deletedAt: z.coerce.date().optional().nullable(),
  User_Role: z
    .object({
      id: z.string(),
      userId: z.string(),
      roleId: z.string(),
      createdAt: z.coerce.date(),
      updatedAt: z.coerce.date(),
    })
    .optional(),
});

export const userEntityOwnerResponseSchema = dbEntityOwnerSchema.extend({
  entityId: z.string().optional(),
  id: z.string().optional(),
  ownerId: z.string().optional(),
});

export const userAgentResponseSchema = dbSigningAgentSchema.partial().extend({
  isConfirmed: z.boolean().optional(),
  isDisabled: z.boolean().optional(),
  fullName: z.string(),
  id: z.string().uuid(),
  firstName: z.string().nullable(),
  middleName: z.string().nullable().optional(),
  lastName: z.string().nullable(),
  email: z.string().nullable(),
  confirmedAt: z.coerce.date().optional(),
  suffix: z.string().nullable().optional(),
  timezone: z.string().nullable().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional().optional(),
  deletedAt: z.coerce.date().nullable().optional(),
  Entity_Owner: userEntityOwnerResponseSchema.optional(),
});

export const legacySequelizeUserSchema = z.object({
  isConfirmed: z.boolean(),
  isDisabled: z.boolean(),
  fullName: z.string(),
  id: z.string(),
  firstName: z.string().nullable(), // TODO: verify why it is null
  middleName: z.string().nullable(),
  lastName: z.string().nullable(),
  email: z.string().email(),
  confirmedAt: z.coerce.date().nullable(),
  suffix: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullable(),
  smsOptInRequestedAt: z.coerce.date().nullable(),
  smsOptInConfirmedAt: z.coerce.date().nullable(),
  smsOptOutRequestedAt: z.coerce.date().nullable(),
  maritalStatus: z.string().nullable(),
  liveStock: z.string().nullable(),
  farmerType: z.string().nullable(),
  ssn: z.string().nullable(),
  dob: z.coerce.date().nullable(),
  mobilePhoneNumber: z.string().nullable(),
  personalCampaignMessage: z.string().nullable(),
  roles: z.array(roleSchema),
  // @note legacy cookie props
  timezone: z.string().nullable(),
  agents: z.array(userAgentResponseSchema).optional(),
  avatar: z
    .union([
      dbMediaSchema.extend({
        Record_Media: dbRecordMediaSchema,
      }),
      // FIXME: Remove this URL if found to not be in use
      z.string().url(),
    ])
    .optional()
    .nullable(),
  avatarUrl: z.string().url().optional(),
});

export type LegacySequelizeUser = z.infer<typeof legacySequelizeUserSchema>;
